import { graphql } from "relay-runtime"

export const deDeleteRecommendedMedicationMutation = graphql`
  mutation deDeleteRecommendedMedicationMutation($input: De_deleteRecommendedMedicationInput!, $connections: [ID!]!) {
    deDeleteRecommendedMedication: de_deleteRecommendedMedication(input: $input) {
      de_RecommendedMedication {
        id @deleteEdge(connections: $connections)
      }

      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
